import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import KnowYourDisease from "@/pages/KnowYourDisease";
import BlogDetail from "@/pages/BlogDetail";
import KnowYourMedications from "@/pages/KnowYourMedications";
import MedicationDetail from "@/pages/MedicationDetail";
import Diet from "@/pages/Diet";
import DietBlogDetail from "@/pages/DietBlogDetail";
import Exercise from "@/pages/Exercise";
import ExerciseBlogDetail from "@/pages/ExerciseBlogDetail";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/know-your-disease" element={<KnowYourDisease />} />
          <Route path="/know-your-disease/:id" element={<BlogDetail />} />
          <Route path="/know-your-medications" element={<KnowYourMedications />} />
          <Route path="/know-your-medications/:id" element={<MedicationDetail />} />
          <Route path="/diet" element={<Diet />} />
          <Route path="/diet/blog/:id" element={<DietBlogDetail />} />
          <Route path="/exercise" element={<Exercise />} />
          <Route path="/exercise/blog/:id" element={<ExerciseBlogDetail />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
        <Footer />
      </BrowserRouter>
      <Toaster richColors position="top-center" />
    </div>
  );
}

export default App;
